export const BASE_URL = "https://cyber-shop-mern.vercel.app";
